import type { ReleasePlatform } from '@/core/data/updateLogs';

/** Platform silhouettes, kept inline so labels and colors follow the active theme. */
export function PlatformIcon({
  platform,
  size = 20,
}: {
  platform: ReleasePlatform;
  size?: number;
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      {platform === 'web' ? (
        <g stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" />
          <path d="M8 22h8m-4-5v5" />
        </g>
      ) : platform === 'android' ? (
        <g fill="currentColor">
          <path d="M5 9a7 7 0 0 1 14 0H5Zm0 2h14v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-8Z" />
          <path
            d="m7 4-2-3m12 3 2-3M2 11v7m20-7v7M8 20v3m8-3v3"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle cx="9" cy="6.5" r=".8" fill="var(--platform-eye, #172015)" />
          <circle cx="15" cy="6.5" r=".8" fill="var(--platform-eye, #172015)" />
        </g>
      ) : (
        <g fill="currentColor">
          <path
            d="M15.9 1c.2 2-1.3 4-3.6 4.2-.2-2 1.4-3.8 3.6-4.2Zm4.4 16.6c-.5 1.3-.8 1.9-1.5 3-1 1.4-2.3 3.1-4 3.1-1.4 0-1.8-.9-3.7-.9s-2.3.9-3.7.9c-1.6 0-2.9-1.5-3.9-3-2.7-4-3-9.3-1.3-11.9 1.2-1.8 3-2.9 4.8-2.9 1.4 0 2.3.9 3.6.9s2-.9 3.6-.9c1.5 0 3.1.8 4.3 2.2-3.8 2.1-3.2 7.5 1.8 9.5Z"
            transform="translate(2 0) scale(.9)"
          />
        </g>
      )}
    </svg>
  );
}
